import { RefObject } from 'react';

import { useInteraction } from '@r-services/ui-interactions';

export type MouseInformationParams = {
	svg?: RefObject<SVGSVGElement | SVGElement>;
};

export const ShowInteractionInfo = (params: MouseInformationParams): React.ReactElement => {
	const { svg = null } = params;
	const [mouse] = useInteraction(svg);

	return (
		<div style={{
			zIndex: 10,
			maxWidth: '400px',
			backgroundColor: 'rgba(255, 255, 255, 0.55)',
			border: '1px solid #ccc',
			borderRadius: '8px',
			padding: '15px',
			boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)'
		}}>
			<h3 style={{ margin: '0 0 15px 0', fontSize: '16px' }}>Interaction Info</h3>
			<div style={{ fontSize: '12px' }}>
				<div><strong>Active Artifact ID:</strong> {mouse.selected.length > 0 ? mouse.selected.join(', ') : 'none'}</div>
				<div><strong>Active Keys:</strong> {mouse.keys.length > 0 ? mouse.keys.join(', ') : 'none'}</div>

				{/* Mouse Click Information */}
				<div style={{ marginTop: '10px', borderTop: '1px solid #ccc', paddingTop: '10px' }}>
					<div><strong>Mouse Click:</strong> ({mouse.click.x}, {mouse.click.y})</div>
					<div><strong>Mouse Double Click:</strong> ({mouse.dblClick.x}, {mouse.dblClick.y})</div>
				</div>

				{/* Mouse Position Information */}
				<div style={{ marginTop: '10px', borderTop: '1px solid #ccc', paddingTop: '10px' }}>
					<div><strong>Mouse Pointer:</strong> ({mouse.pointer.x}, {mouse.pointer.y})</div>
					<div><strong>Mouse Raw Position:</strong> ({mouse.raw.x}, {mouse.raw.y})</div>
					<div><strong>Mouse PPI:</strong> ({mouse.ppi.x}, {mouse.ppi.y})</div>
				</div>

				{/* Mouse Drag Information */}
				<div style={{ marginTop: '10px', borderTop: '1px solid #ccc', paddingTop: '10px' }}>
					<div><strong>Mouse Drag:</strong> ({mouse.drag.x}, {mouse.drag.y})</div>
					<div><strong>Drag Delta:</strong> ({mouse.drag.dx}, {mouse.drag.dy})</div>
					<div><strong>Drag Distance:</strong> {mouse.drag.distance}</div>
					<div><strong>Keyboard Drag:</strong> ({mouse.drag.kx}, {mouse.drag.ky})</div>
				</div>

				{/* Mouse Movement Information */}
				<div style={{ marginTop: '10px', borderTop: '1px solid #ccc', paddingTop: '10px' }}>
					<div><strong>Mouse Velocity:</strong> ({Number(mouse.velocity.x ?? '0').toFixed(2)}, {Number(mouse.velocity.y ?? '0').toFixed(2)})</div>
					<div><strong>Mouse Swipe:</strong> {mouse.swipe}</div>
				</div>
			</div>
		</div>
	);
};
